import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CheckBox, DragIcon, HideIcon, MicrophoneIcon } from '@room-match/shared-ui-components';
import React, { useEffect, useState } from 'react';
import AudioProgressBar from 'shared/components/AudioProgressBar/AudioProgressBar';
import { useAudioProgressBar } from 'shared/hooks';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { IAgencyTalentPermissionPayload } from 'shared/interfaces/IProfile';
import { AudioDrag, AudioInfo, AudioItemCont, AudioName, CheckNumberCont, Duration } from './item.styles';
const SRC = '/audio1.mp3';

interface Props {
  aud: any;
  src: string;
  idx?: string;
  check?: boolean;
  checked?: boolean;
  checkReturn?: (id: string) => void;
  dragging?: boolean;
  handleAgencyTalentPermissions?: (payload: IAgencyTalentPermissionPayload) => void;
}

function AudioItem({ src, idx, check, checkReturn, checked, aud, dragging, handleAgencyTalentPermissions }: Props) {
  const [audio] = useState(new Audio(src || SRC));
  const { buffered, playing, setPlaying, duration, setDuration, setCurrrentProgress, currrentProgress } =
    useAudioProgressBar();
  const sortable = useSortable({ id: aud.id });
  const { attributes, listeners, isDragging, setNodeRef, transform, transition } = sortable;
  const [show, setshow] = useState(false);
  const { width } = useWindowDimensions();
  const checkClick = (e: any) => {
    e.stopPropagation();
    if (handleAgencyTalentPermissions) {
      handleAgencyTalentPermissions({
        module: 'audio_files',
        callback: () => {
          if (checkReturn) checkReturn(aud);
        },
        ctaText: 'OK',
      });
    }
  };

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform && { ...transform, scaleX: 1, scaleY: 1 }),
    transition,
    opacity: isDragging ? 0 : 1,
  };

  useEffect(() => {
    const getAudioInfo = (e: any) => {
      setDuration(e.target.duration);
    };

    const onEnded = () => {
      setPlaying(false);
    };

    audio.addEventListener('loadedmetadata', getAudioInfo);
    audio.addEventListener('ended', onEnded);

    return () => {
      audio.pause();
      audio.removeEventListener('loadedmetadata', getAudioInfo);
      audio.removeEventListener('ended', onEnded);
    };
  }, [audio, aud, setDuration, setPlaying]);

  const handleClick = () => {
    if (playing) {
      audio.pause();
    } else {
      audio.play();
    }
    setPlaying(!playing);
  };

  return (
    <AudioItemCont ref={setNodeRef} style={style} onMouseOver={() => setshow(true)} onMouseLeave={() => setshow(false)}>
      <MicrophoneIcon onClick={handleClick} style={{ opacity: (!check && show) || (width < 960 && !check) ? 0 : 1 }} />
      <AudioInfo>
        <AudioName onClick={handleClick}>{aud.attributes?.file_name || aud.attributes?.medium_name}</AudioName>
        <Duration>
          {playing ? (
            <AudioProgressBar
              duration={duration}
              currentProgress={currrentProgress}
              buffered={buffered}
              onChange={(e) => {
                if (!audio) return;
                audio.currentTime = e.currentTarget.valueAsNumber;
                setCurrrentProgress(e.currentTarget.valueAsNumber);
              }}
            />
          ) : (
            <>
              {`${'Duration : '}`}
              {duration === 0
                ? '--:--'
                : duration < 3600
                  ? new Date(duration * 1000).toISOString().substring(14, 19)
                  : new Date(duration * 1000).toISOString().substr(11, 8)}
            </>
          )}
        </Duration>
      </AudioInfo>
      {check ? (
        <div style={{ position: 'absolute', right: 0, zIndex: 10 }}>
          <CheckBox checked={checked} onClick={checkClick} />
        </div>
      ) : (
        <CheckNumberCont style={{ position: 'absolute', right: 10, zIndex: 2 }} onClick={checkClick}>
          {dragging || (width > 960 && !show) ? idx : <HideIcon style={{ width: 18, height: 18, cursor: 'pointer' }} />}
        </CheckNumberCont>
      )}
      {!check && (show || width < 960) && (
        <AudioDrag {...attributes} {...listeners} className="img-item-hover">
          <DragIcon style={{ marginLeft: -2 }} />
        </AudioDrag>
      )}
    </AudioItemCont>
  );
}

export default AudioItem;
